module.exports = __webpack_public_path__ + "img/abd4e59.jpg";